import { render, staticRenderFns } from "./UploadContent.vue?vue&type=template&id=39664b7c"
import script from "./UploadContent.vue?vue&type=script&lang=js"
export * from "./UploadContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports